export default {
  order: 4,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'WIND_SPEED',
    order: 4,
    type: 'remoteDataLayer',
    uuid: '9fa60bd9-0643-4d0a-a569-0036e902d1f9',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      colormap: null,
      inputRange: null,
      legendConfig: {
        name: {
          en: 'Wind Speed Potential at 50m (m/s)',
          es: 'Potencial de velocidad del viento a 50 m (m/s)',
          fr: 'Potentiel de vitesse du vent à 50m (m/s)',
          id: 'Potensi Kecepatan Angin pada 50m (m/s)',
          ka: 'Wind Speed Potential at 50m (m/s)',
          pt: 'Potencial de Velocidade do Vento a 50m (m/s)',
          zh: '50米处的风速潜力（米/秒）',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(237, 248, 177)',
            name: {
              en: '≤1',
              fr: '≤1',
              es: '≤1',
              pt: '≤1',
              id: '≤1',
              zh: '≤1',
              ka: '≤1',
            },
          },
          {
            color: 'rgb(199, 233, 180)',
            name: {
              en: '≤3',
              fr: '≤3',
              es: '≤3',
              pt: '≤3',
              id: '≤3',
              zh: '≤3',
              ka: '≤3',
            },
          },
          {
            color: 'rgb(65, 182, 196)',
            name: {
              en: '≤6',
              fr: '≤6',
              es: '≤6',
              pt: '≤6',
              id: '≤6',
              zh: '≤6',
              ka: '≤6',
            },
          },
          {
            color: 'rgb(34, 94, 168)',
            name: {
              en: '≤10',
              fr: '≤10',
              es: '≤10',
              pt: '≤10',
              id: '≤10',
              zh: '≤10',
              ka: '≤10',
            },
          },
          {
            color: 'rgb(12, 44, 132)',
            name: {
              en: '>10',
              fr: '>10',
              es: '>10',
              pt: '>10',
              id: '>10',
              zh: '>10',
              ka: '>10',
            },
          },
        ],
      },
      interactionConfig: {},
      outputRange: null,
    },
    id: 'WIND_SPEED',
    type: 'base-tile-layer',
    url: 'https://tiles.globalforestwatch.org/dtu_wb_wind_speed_potential_2001_2010/latest/default/{z}/{x}/{y}.png',
    technicalName: 'dtu_wb_wind_speed_potential_2001_2010',
    label: {
      en: 'Wind Speed Potential',
      es: 'Potencial de velocidad del viento',
      fr: 'Potentiel de vitesse du vent',
      id: 'Potensi Kecepatan Angin',
      ka: 'Wind Speed Potential',
      pt: 'Potencial de Velocidade do Vento',
      zh: '风速潜力',
    },
    sublabel: {
      en: '1 km, global, DTU/World Bank Group/ESMAP',
      es: '1 km, global, DTU/Grupo del Banco Mundial/ESMAP',
      fr: '1 km, mondial, DTU/Groupe de la Banque mondiale/ESMAP',
      id: '1 km, global, DTU/Kelompok Bank Dunia/ESMAP',
      ka: '1 km, global, DTU/World Bank Group/ESMAP',
      pt: '1 km, global, DTU/Grupo do Banco Mundial/ESMAP',
      zh: '1公里，全球，DTU/世界银行集团/ESMAP',
    },
  },
  isError: false,
};
